var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShockNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F0FBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.3332V17.9999M18 20.6665H18.0067M23.25 14.1799C23.7167 14.4452 24.0033 14.9419 24 15.4786V20.3346C24 20.8739 23.7047 21.3712 23.228 21.6332L18.728 24.4799C18.5049 24.6024 18.2545 24.6666 18 24.6666C17.7455 24.6666 17.4951 24.6024 17.272 24.4799L12.772 21.6332C12.5388 21.5058 12.3441 21.318 12.2083 21.0895C12.0725 20.8611 12.0005 20.6003 12 20.3346V15.4779C12 14.9386 12.2953 14.4419 12.772 14.1799L17.272 11.5266C17.5017 11.3999 17.7597 11.3335 18.022 11.3335C18.2843 11.3335 18.5423 11.3999 18.772 11.5266L23.272 14.1799H23.25Z",
    stroke: "#1E5915",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShockNotifications);
export default __webpack_public_path__ + "static/media/shock-notifications.32ed754937fa9de75fa2553d81642dc5.svg";
export { ForwardRef as ReactComponent };